import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import DefaultInfoCard from "reusables/Cards/InfoCards/DefaultInfoCard";
import SectionLayout from "reusables/layouts/SectionLayout";

const audiences = [
  {
    icon: "cleaning_services",
    title: "Cleaning Companies",
    description:
      "Track cleaners across multiple sites. Verify clock-in locations, manage recurring schedules, and calculate pay automatically.",
  },
  {
    icon: "security",
    title: "Security Firms",
    description:
      "Monitor guard attendance at multiple locations. Get real-time alerts for late arrivals or early departures.",
  },
  {
    icon: "construction",
    title: "Facilities & Maintenance",
    description:
      "Assign one-time or recurring maintenance jobs with GPS verification. Manage multi-site teams from a single dashboard.",
  },
  {
    icon: "domain",
    title: "Property Management",
    description:
      "Coordinate staff across managed properties. Combine with Spechs Property Services for a fully integrated operation.",
  },
];

function ForWho() {
  return (
    <SectionLayout
      mt={20}
      title="Built for field-based industries"
      description="Any company that manages staff across multiple locations can benefit from Spechs Workforce."
      contents={
        <MKBox mt={4}>
          <Container>
            <Grid container spacing={3}>
              {audiences.map(({ icon, title, description }) => (
                <Grid key={title} item xs={12} md={6}>
                  <DefaultInfoCard icon={icon} title={title} description={description} />
                </Grid>
              ))}
            </Grid>
          </Container>
        </MKBox>
      }
    />
  );
}

export default ForWho;
